module.exports = __webpack_public_path__ + "img/pin-lock@3x.1fd50f77.png";